// Globals that injected bot tags reference but our GTM container (GTM-TN5PVCN) never does.
// gtag and fbq are deliberately absent: the container uses both, so their errors can be real.
// Re-check the container before adding a name (docs/sentry-findings.md A1, group C).
const FOREIGN_GLOBALS = [
  'ym', '_omlfp', 'mida', 'amplitude', 'prestashop', '__NEXT_DATA__', 'OneSignal', 'Tawk_API',
  'LeadSource', 'olytics', 'sfWebInteractionsDataLayer', 'PGdataLayer', '_LT', 'gsc', 'oaiq', '_cio',
  '_etmc', 'MsCrmMkt', 'FundraiseUp', 'Weglot', 'ytag', 'snowplow', 'Osano', 'globalData',
  'jrConfigGlobal', 'webVitals', 'ecommerceExt', 'ecommerceExt_GA4', '_googWcmGet', 'tp', 'App'
].join('|');

export const IGNORE_ERRORS = [
  // carried over from the old per-pack lists
  'Failed to fetch',
  'Non-Error promise rejection captured with value: Object Not Found Matching Id:',
  'Can\'t find variable: instantSearchSDKJSBridgeClearHighlight',
  'Can\'t find variable: gmo',
  'Invalid call to runtime.sendMessage(). Tab not found.',
  'Java exception was raised during method invocation',
  'Java object is gone',
  // A. Meta / Android in-app browsers
  /window\.webkit\.messageHandlers/,
  /WKWebView API client/,
  /Java bridge method invocation/,
  // C. injected foreign tag code (Chrome and Safari wording)
  new RegExp(`^ReferenceError: (?:(?:${ FOREIGN_GLOBALS }) is not defined|Can't find variable: (?:${ FOREIGN_GLOBALS })$)`),
  // E. network / aborted / Safari body-read on navigation
  /NotReadableError/,
  /^TypeError: Load failed$/,
  /NetworkError when attempting/,
  /AbortError/,
  // F. storage / privacy mode
  /localStorage/,
  /The operation is insecure/,
  /Indexed ?Database/,
  /Database deleted/,
  /QuotaExceeded/,
  // G. DOM mutated by Google Translate / extensions
  /Failed to execute '(insertBefore|removeChild)' on 'Node'/,
  /The object can not be found here/,
  // I. opaque promise rejections
  /Event `CustomEvent` \(type=unhandledrejection\)/,
  /Object captured as promise rejection with keys: \[object has no keys\]/,
  /Non-Error promise rejection captured with value: (null|undefined)$/,
  // J. iOS-injected script (658)
  /Can't find variable: EmptyRanges/
];

export const DENY_URLS = [
  // B. browser extensions
  /^(chrome|moz|safari(-web)?)-extension:\/\//,
  /^chrome:\/\//,
  /^webkit-masked-url:/,
  /bookmarklet\.js/,
  /\/snapshop\//,
  /\/widgetapp\//,
  /chatPanel/,
  /webappstoolbarba\.texthelp\.com/,
  // H. vendor scripts we load
  /script\.hotjar\.com/,
  /paypal\.com/,
  /affirm\.com/,
  /graph\.facebook\.com/,
  /connect\.facebook\.net/,
  // C. OneTrust, which we don't load
  /cookielaw\.org/,
  /otSDKStub/
  // googletagmanager.com is deliberately not here: our own GTM tags fail with the same stack
];

const GTM_FRAME = /googletagmanager\.com\/gtm\.js/;
const HEADLESS_UA = /HeadlessChrome|X11; Linux x86_64/;
const CHUNK_ERROR = /ChunkLoadError|Loading CSS chunk/;

const exceptionOf = (event) => {
  const values = event.exception?.values || [];
  return values[values.length - 1] || {};
};

// Returns null to drop the event; otherwise the (possibly tagged) event.
export const filterEvent = (event, hint, env) => {
  const {
    hostname, webdriver, userAgent, referrer, ourHosts, stagingHost
  } = env;
  if (webdriver && hostname !== stagingHost) return null;
  const stack = hint?.originalException?.stack;
  if (stack && stack.toString().includes('puppeteer')) return null;
  const exception = exceptionOf(event);
  if (CHUNK_ERROR.test(`${ exception.type }: ${ exception.value }`) && !referrer && HEADLESS_UA.test(userAgent)) return null;

  const frames = exception.stacktrace?.frames || [];
  const tags = { ...event.tags };
  if (frames.some((f) => GTM_FRAME.test(f.filename || ''))) tags.source = 'gtm';
  if (!ourHosts.includes(hostname)) tags.foreign_host = hostname;
  return { ...event, tags };
};
